import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "./Logo";
import api, { apiError } from "@/lib/api";
import { DEPARTMENTS, COLLECTIONS } from "@/data/site";

export function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the inner circle.");
      setEmail("");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <footer className="border-t border-white/10 bg-ink" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <Logo />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-cream/60">
              HYEAMAN, also known as Street Sheriff, is editorial luxury streetwear where no one is left behind — engineered for those who wear confidence.
            </p>
            <form onSubmit={subscribe} className="mt-8 flex max-w-sm border border-white/15" data-testid="newsletter-form">
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email" data-testid="newsletter-email"
                className="flex-1 bg-transparent px-4 py-3 text-sm text-cream placeholder:text-mutedgray outline-none"
              />
              <button disabled={loading} data-testid="newsletter-submit"
                className="bg-gold px-5 text-xs font-bold uppercase tracking-widest text-black transition hover:bg-gold-bright">
                {loading ? "…" : "Join"}
              </button>
            </form>
          </div>

          <FooterCol title="Departments" links={DEPARTMENTS.map((d) => ({ label: d.label, to: `/shop?department=${d.key}` }))} />
          <FooterCol title="Collections" links={COLLECTIONS.map((c) => ({ label: c.label, to: `/shop?collection=${c.key}` }))} />
          <FooterCol title="Client Care" links={[
            { label: "Street Sheriff", to: "/street-sheriff" },
            { label: "About", to: "/about" }, { label: "Lookbook", to: "/lookbook" }, { label: "Contact", to: "/contact" },
            { label: "Shipping", to: "/shipping" }, { label: "Returns", to: "/returns" },
            { label: "Size Guide", to: "/size-guide" },
          ]} />
          <FooterCol title="Legal" links={[
            { label: "Privacy", to: "/privacy" }, { label: "Terms", to: "/terms" },
            { label: "Operations", to: "/staff/login" },
          ]} />
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-cream/40 sm:flex-row">
          <p>© {new Date().getFullYear()} HYEAMAN · Street Sheriff. Built for Greatness.</p>
          <p className="font-mono uppercase tracking-[0.25em] text-gold/60">Wear Confidence · No One Is Left Behind</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <h4 className="overline-label mb-5">{title}</h4>
      <ul className="space-y-3">
        {links.map((l) => (
          <li key={l.label}>
            <Link to={l.to} className="text-sm text-cream/60 transition hover:text-gold">{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
